import { InjectedConnector } from "@web3-react/injected-connector";
import { NetworkConnector } from "@web3-react/network-connector";

const RPC_URLS = {
  1: "https://mainnet.infura.io/v3/",
  4: "https://rinkeby.infura.io/v3/",
  5: "https://goerli.infura.io/v3/",
  137: "https://polygon-mainnet.infura.io/v3/",
  80001: "https://polygon-mumbai.infura.io/v3/",
  31337: "http://localhost:8545",
};

export const network = new NetworkConnector({
  urls: RPC_URLS,
  defaultChainId: 1,
});

export const injected = new InjectedConnector({
  supportedChainIds: Object.keys(RPC_URLS).map((key) => parseInt(key, 10)),
});

export const isUnsupportedChainError = (errorMessage: string): boolean =>
  errorMessage.startsWith("Unsupported chain");

export const isNoMetamaskError = (errorMessage: string): boolean =>
  errorMessage.startsWith("No Ethereum provider was found");

export const Messages: {
  [key: string]: string;
} = {
  UnsupportedChainError:
    "The only network we support is ethereum.\nPlease Change your network.",
  NoMetamaskError:
    "Your metamask wallet is not found.\nPlease install metamask wallet in your browser.",
};
